import { render, staticRenderFns } from "./DocumentFileTable.vue?vue&type=template&id=5f0e1976&scoped=true&"
import script from "./DocumentFileTable.vue?vue&type=script&lang=js&"
export * from "./DocumentFileTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0e1976",
  null
  
)

export default component.exports